import React, { useState} from "react";
import Header from "../components/Header";
import Coupon from "../components/Coupon";
import Nodata from "../components/NoData";
import {alert, confirm} from "../components/MegConfirmAlert";
import { useTranslation } from 'react-i18next';

export default function OrderCoupon(props) {
    const { t } = useTranslation();
    const [checkData, setCheckData] = useState({});
    const fn_useCheck = () => {        
        if(checkData.couponIssuHistSn){

            if(checkData.mummUsePosblAmount > props.totGoodsAmount){
                alert(t(`Message.discount_info_invalid_use_coupon1` , {mummUsePosblAmount : checkData.mummUsePosblAmount.toLocaleString('ko-KR')} ));
            }else{
                let totGoodsAmount = Number(props.totGoodsAmount);
                let lastSetleAmount = Number(props.totGoodsAmount);
    
                const dlvyCtAmount = Number(props.dlvyCtAmount);
                const mlgUseAmount = Number(props.mlgUseAmount);
    
                lastSetleAmount += dlvyCtAmount
                lastSetleAmount -= mlgUseAmount
                if(checkData.couponValueUnitCode === '01'){
                    const couponVal = totGoodsAmount * (Number(checkData.couponValue) / 100);
                    if(lastSetleAmount < couponVal){
                        alert(t(`Message.discount_info_invalid_use_coupon2`))
                        props.closeFn()
                    }else{
                        if(Number(checkData.mxmmDscntAmount) < couponVal){
                            checkData.couponDscntAmount = checkData.mxmmDscntAmount;                    
                        }else{
                            checkData.couponDscntAmount = couponVal;                        
                        }
                        props.setCouponInfo(checkData)
                        props.closeFn()   
                    }
                }else{
                    var couponVal = checkData.couponValue;
                    if(lastSetleAmount < couponVal){
                        alert(t(`Message.discount_info_invalid_use_coupon2`))
                        props.closeFn()
                    }else{
                        checkData.couponDscntAmount = couponVal;
                        props.setCouponInfo(checkData)
                        props.closeFn()    
                    }
                }
            }

        }else{
            alert(t(`Message.coupon_list_select_coupon`))
        }
    }
    return(
        <div className={props.modal?'modalPage':'justPage'}>
            <Header  type={props.modal?'modal':'cart'}  closeFn={props.closeFn}  pageTitle={t(`Message.discount_info_sale_coupon`)}/>
            {!props.data?(
            <div className="floatCenter">
                <Nodata text={t(`Message.coupon_list_bottom_sheet_coupon_empty`)}/>                
            </div> 
            ) : (
            <div>
                <div className="cpRadioWr">
                    {props.data && props.data.map((obj, index) => (
                    <Coupon key={index}
                        type="radio"
                        discount={obj.couponValue + obj.couponValueUnitCodeNm+' 할인'}
                        name={obj.couponSj}
                        info={t(`Message.coupon_list_bottom_sheet_coupon_condition_2` , {mxmmAmt : obj.mxmmDscntAmount.toLocaleString('ko-KR')}) + ', ' +t(`Message.coupon_list_bottom_sheet_coupon_condition_3`, {mummAmt : obj.mummUsePosblAmount.toLocaleString('ko-KR')} )  }
                        date={"~ "+obj.useEndDe}
                        clickFn={setCheckData}
                        couponIssuHistSn = {props.couponIssuHistSn?props.couponIssuHistSn:0}
                        obj={obj}
                    />
                    ))}                     
                </div>
                <button type="button" className="floatBtn" onClick={fn_useCheck}>{t(`Message.coupon_list_use_coupon`)}</button>
            </div>
            )}
        </div>
    );
};